// extracted by mini-css-extract-plugin
export default {"root":"ModuleSpecialRatesForm_root__2M6At","field-group":"ModuleSpecialRatesForm_field-group__IUPKf","contract-number-field":"ModuleSpecialRatesForm_contract-number-field__T6VS2"};